import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { Loan, EmployeeRef, LoanScheduleDate, Parameter, Employee, PeriodTypeEnum, PayrollParameters, LoanParameters, Dictionary, ScheduleDate, LoanStatus } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { DatePipe } from '@angular/common';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { environment } from 'projects/bimbo/src/environments/environment';
import * as moment from 'moment';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';

@Component({
  selector: 'app-rl-details',
  templateUrl: './rl-details.component.html',
  styleUrls: ['./rl-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RlDetailsComponent implements OnInit, OnDestroy {

  //////////////////////////////////////
  payrollParameter: PayrollParameters | null = null;
  retirementSavingParameter: Parameter | null = null;
  retirementLoanParameter: LoanParameters | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  authUser: Employee;
  //////////////////////////////////////

  displayedUpFrontColumns: string[] = ['depositDateBiWeek', 'depositDateWeek', 'totalAmount', 'paid'];
  displayedFixedColumns: string[] = ['biWeekNumber', 'weekNumber', 'year', 'capitalAmortization', 'capital', 'interest', 'totalAmount', 'paid'];
  showLoanStatementReport = true;
  showLoanRestructuring = false;
  showLoanAdvancePayment = false;
  loanCopy: Loan = new Loan();
  originalLoan: Loan = new Loan();
  newLoan: Loan = new Loan();
  textWage = '';
  totalDebtAmount = 0;
  //////////////////
  defaultRouting = new EmployeeRef();
  //////////////////
  appLogicSubs: Subscription;
  loanType: boolean;
  newLoanType: boolean;
  displaySave: boolean = true;
  requestedNumberOfPayments: number;
  requestedAmount: number;

  restucturedMessage = '';

  @Input() contentLocation: AppState;
  constructor(public authService: AuthenticationService, public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService, private datePipe: DatePipe, private ui: UiService) {

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];
    const payrollParameters = this.logicService.dataManager.parameterDataLoader.payrolls ? this.logicService.dataManager.parameterDataLoader.payrolls : [];
    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;

    this.retirementSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    //const tempP = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.loanParameterAppliesTo(this.currentEmployee));
    const temp = [this.retirementSavingParameter].find(e => e.loanParameterAppliesTo(this.currentEmployee));
    this.retirementLoanParameter = temp.applicableLoanParameter;
    this.payrollParameter = payrollParameters.find(e => e.payrollAppliesTo(this.currentEmployee));
    this.totalDebtAmount = this.currentEmployee.retirementSaving ? this.currentEmployee.totalRetirementDebt : 0;

    const paymentDaily = this.currentEmployee.workInformation ? this.currentEmployee.workInformation.wage ? this.currentEmployee.workInformation.wage.amount : 0 : 0;

    this.originalLoan = new Loan(this.currentEmployee.retirementSavingsLoan.toAny());
    const sd: any = this.currentEmployee.retirementSavingsLoan.scheduleDates.toObject();
    const keys = Object.keys(sd);
    for (const key of keys) {
      const scheduleDate = new LoanScheduleDate(sd[key]);
      this.originalLoan.scheduleDates.add(key, scheduleDate);
    }

    this.loanCopy = new Loan(this.originalLoan.toAny());
    const sdCopy: any = this.currentEmployee.retirementSavingsLoan.scheduleDates.toObject();
    const keysCopy = Object.keys(sdCopy);
    for (const key of keysCopy) {
      const scheduleDate = new LoanScheduleDate(sdCopy[key]);
      this.loanCopy.scheduleDates.add(key, scheduleDate);
    }

    this.loanType = this.originalLoan.interestType === 'upFront' || this.originalLoan.interestType === '' ? false : true;


    if (this.currentEmployee.workInformation.wage.wageName === 'CATORCENAL') {
      this.displayedUpFrontColumns.splice(1, 1);
      this.displayedFixedColumns.splice(1, 1);
    } else {
      this.displayedUpFrontColumns.splice(0, 1);
      this.displayedFixedColumns.splice(0, 1);
    }

  }

  ngOnInit() {
    this.newLoan = new Loan();
  }

  loanStatementReport() {
    this.loanCopy = new Loan(this.originalLoan.toAny());
    const sdCopy: any = this.currentEmployee.retirementSavingsLoan.scheduleDates.toObject();
    const keysCopy = Object.keys(sdCopy);
    for (const key of keysCopy) {
      const scheduleDate = new LoanScheduleDate(sdCopy[key]);
      this.loanCopy.scheduleDates.add(key, scheduleDate);
    }
    this.showLoanStatementReport = true;
    this.showLoanRestructuring = false;
    this.showLoanAdvancePayment = false;

  }

  loanRestructuring() {

    this.loanCopy = new Loan(this.originalLoan.toAny());
    const sdCopy: any = this.currentEmployee.retirementSavingsLoan.scheduleDates.toObject();
    const keysCopy = Object.keys(sdCopy);
    for (const key of keysCopy) {
      const scheduleDate = new LoanScheduleDate(sdCopy[key]);
      this.loanCopy.scheduleDates.add(key, scheduleDate);
    }
    this.showLoanStatementReport = false;
    this.showLoanRestructuring = true;
    this.showLoanAdvancePayment = false;

  }

  loanAdvancePayment() {
    this.loanCopy = new Loan(this.originalLoan.toAny());
    const sdCopy: any = this.currentEmployee.retirementSavingsLoan.scheduleDates.toObject();
    const keysCopy = Object.keys(sdCopy);
    for (const key of keysCopy) {
      const scheduleDate = new LoanScheduleDate(sdCopy[key]);
      this.loanCopy.scheduleDates.add(key, scheduleDate);
    }
    this.showLoanStatementReport = false;
    this.showLoanRestructuring = false;
    this.showLoanAdvancePayment = true;
  }

  /////////

  shouldAllowRestructuring(employee: Employee, originalLoan: Loan): boolean {

    const isTodayPayroll = this.logicService.isTodayAPayrollDayForEmployee(employee);
    if (isTodayPayroll) {
      this.restucturedMessage = 'Existe un candado en este momento por periodo de pagos, inténtelo mas tarde.'
      return isTodayPayroll;
    }

    const cycleType = employee.workInformation.wage.wageName === 'CATORCENAL' ? 15 : 8;
    const lastDate = moment(originalLoan.approvedAt);
    const days = moment().subtract(cycleType, 'days');

    if (days.isSameOrBefore(lastDate, 'day')) {
      this.restucturedMessage = 'Es necesario que exista al menos un pago entre reestructuras.';
      return true;
    }

    return false;

  }

  get firstPaymentDate(): Date | null {

    const al = this.loanCopy;

    if (al) {
      const schedulePayments = al.scheduleDates.values();
      if (schedulePayments[0]) {
        return schedulePayments[0].depositDate;
      }
    }

    return null;

  }

  get paidTotal(): number {
    const al = this.loanCopy;
    if (al) {
      const total = al.scheduleDates.values().filter(element => element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : 0), 0);
      return total;
    }

    return 0;
  }

  get pendingTotal(): number {
    const al = this.loanCopy;
    if (al) {
      const pending = al.scheduleDates.values().filter(element => !element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : prev), 0);
      return Number(pending.toFixed(2));
    }

    return 0;
  }

  get remainingPayments(): number {

    const al = this.loanCopy;
    if (al) {
      const pending = al.scheduleDates.values().filter(element => !element.paid).length;
      return pending;
    }

    return 0;

  }

  get remainderPayment(): number {
    const total = this.pendingTotal;
    const interest = 0;
    return total - interest;
  }

  get nextPaymentDate(): Date {
    const dp = this.loanCopy.scheduleDates.values().find(element => !element.paid);
    if (dp) {
      return dp.depositDate;
    }
    return new Date();
  }

  get maxLoanAmount(): number {
    return this.retirementLoanParameter.maxLoanAmount(this.currentEmployee, this.logicService.shouldCalculateAVGWage(this.currentEmployee));
  }

  get loanInterest(): number {
    return this.retirementLoanParameter.loanInterest(this.currentEmployee);
  }

  get maxNumberOfPayments(): number {
    const maxPayments : number = this.retirementLoanParameter.maxNumberOfPayments(this.currentEmployee);

    if (this.retirementLoanParameter.dateMaxPayments) {
      const m1 = moment();
      const dateMaxPayments = this.retirementLoanParameter.dateMaxPayments.getTime();
      const nowMilSecs = m1.toDate().getTime();
      const nextPaymentsLimit = this.payrollParameter.payrollDatesForLoans.filter(pd => pd.active === true && pd.startDate.getTime() >= nowMilSecs && pd.startDate.getTime() <= dateMaxPayments);      

      if (nextPaymentsLimit.length >= maxPayments || nextPaymentsLimit.length == 0) {
        return maxPayments;
      } else {
        return nextPaymentsLimit.length;
      }
    } else {
      return maxPayments;
    }

  }

  get discountPerPayment(): number {
    return this.newLoan.requestedAmount && this.newLoan.requestedNumberOfPayments ? (this.newLoan.requestedAmount / this.newLoan.requestedNumberOfPayments) : 0;
  }

  calculate() {

    if (this.newLoan.requestedAmount === 0) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a 0',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments < 2) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments > this.maxNumberOfPayments) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea menor al máximo número de cuotas',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.maxLoanAmount < this.newLoan.requestedAmount) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto del préstamo sea menor al monto máximo.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.remainderPayment > this.newLoan.requestedAmount) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La cantidad solicitada debe de ser mayor al total a liquidar del préstamo a reestructurar',
          close: 'Aceptar'
        }
      });

      return;
    }

    const m1 = moment();
    const nowMilSecs = m1.toDate().getTime();
    const nextPayments = this.payrollParameter.payrollDatesForLoans.filter(pd => pd.active === true && pd.startDate.getTime() >= nowMilSecs);
    this.requestedAmount = this.newLoan.requestedAmount;
    this.newLoan.requestedNumberOfPayments = Math.trunc(this.newLoan.requestedNumberOfPayments);
    this.requestedNumberOfPayments = this.newLoan.requestedNumberOfPayments;
    this.newLoan = this.retirementLoanParameter.calculateLoan(environment.variableLoan, this.currentEmployee, this.newLoan.requestedNumberOfPayments, this.newLoan.requestedAmount, this.loanInterest, this.payrollParameter, nextPayments);
    this.newLoanType = this.newLoan.interestType === 'upFront' || this.newLoan.interestType === '' ? false : true;

    const thirtyPercentRule = (0.30 * this.currentEmployee.periodWage);
    const wageLiq = (0.30 * this.currentEmployee.wageLiquidity);
    const max: number = Math.max(thirtyPercentRule, wageLiq);


if(max >= this.discountPerPayment && this.newLoan.requestedAmount > 0){
this.displaySave = false; 
}

    if (max < this.discountPerPayment) {

      this.newLoan.scheduleDates = new Dictionary<LoanScheduleDate>(LoanScheduleDate);
      this.displaySave = true; 
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto de las cuotas a pagar excederían tu capacidad de pago, tu capacidad de pago por cuota es de: $ ' + max.toFixed(2),
          close: 'Aceptar'
        }
      });
      return;

    }

  }

  cancel(tabIndex: number, contentIndex: number | null) {
    const cancelRegistration = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelRegistration.afterClosed().subscribe(result => {
      if (result) {
        this.contentLocation.tabIndex = tabIndex;
        this.contentLocation.contentIndex = contentIndex;
        this.contentLocation.detailIndex = 0;
        this.loanCopy = new Loan();
        this.originalLoan = new Loan();
      }
    });
  }

  cancelSimple(tabIndex: number, contentIndex: number | null) {
    this.contentLocation.tabIndex = tabIndex;
    this.contentLocation.contentIndex = contentIndex;
    this.contentLocation.detailIndex = 0;
    this.loanCopy = new Loan();
    this.originalLoan = new Loan();
  }

  saveRestructuredLoan() {

    if (this.newLoan.requestedAmount !== this.requestedAmount || this.newLoan.requestedNumberOfPayments !== this.requestedNumberOfPayments) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Favor de validar que el monto y el numero de cuotas coincida con el calculado.',
          close: 'Aceptar'
        }
      });
      return;
    }

    if (this.remainderPayment > this.newLoan.requestedAmount) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La cantidad solicitada debe de ser mayor al total a liquidar del préstamo a reestructurar',
          close: 'Aceptar'
        }
      });

      return;
    }

    if (this.newLoan.requestedNumberOfPayments < 2) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;
    }

    if (this.newLoan.requestedAmount === 0) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a 0',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.maxLoanAmount < this.newLoan.requestedAmount) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto del préstamo sea menor al monto máximo.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments > this.maxNumberOfPayments) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea menor al máximo número de cuotas permitido',
          close: 'Aceptar'
        }
      });

      return;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Desea liquidar su préstamo en la siguiente paga, así como solicitar un nuevo préstamo?`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(result => {
      if (result) {
        const authUser = this.logicService.dataManager.principalDataLoader.employee && this.logicService.dataManager.principalDataLoader.employee.workInformation ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
        this.ui.showSpinner();
        const newLoan = new Loan(this.newLoan.toAny());
        newLoan.scheduleDates = this.newLoan.scheduleDates;
        const id = this.originalLoan.loanID;
        this.dataService.markRestructuredLoan(id).then(async () => {

          newLoan.status = LoanStatus.REVIEW;
          newLoan.active = true;
          newLoan.typeID = '02';
          newLoan.type = 'retirement';
          newLoan.employeeRef.employeeNumber = this.currentEmployee.workInformation.employeeNumber;
          newLoan.employeeRef.uid = this.currentEmployee.uid;
          newLoan.employeeRef.email = this.currentEmployee.contactInformation.item('workEmail') ? this.currentEmployee.contactInformation.item('workEmail').value : '';
          newLoan.employeeRef.displayName = this.currentEmployee.displayName;
          newLoan.restructuredID = id;

          newLoan.supervisor.employeeNumber = this.currentEmployee.workInformation.supervisor.employeeNumber;
          newLoan.supervisor.uid = this.currentEmployee.workInformation.supervisor.employeeNumber;
          newLoan.supervisor.email = this.currentEmployee.workInformation.supervisor.email ? this.currentEmployee.workInformation.supervisor.email : '';
          newLoan.supervisor.displayName = this.currentEmployee.workInformation.supervisor.displayName;
          newLoan.supervisor.userName = this.currentEmployee.workInformation.supervisor.displayName;
          newLoan.approvedBy.email = authUser.uid;

          const activePeriod = this.retirementSavingParameter;
          if (activePeriod) {
            newLoan.periodId = activePeriod.parametersID;
          }

          const employeeSeniorityInYears: number = this.currentEmployee.employeeSeniorityInYears;
          if (employeeSeniorityInYears >= 2) {

            newLoan.status = LoanStatus.ACTIVE;
            const startOfDay = newLoan.convertToCDMXSEC(new Date());
            const transport = newLoan.generateTransportMessage(this.originalLoan);
            const loansArray = Object.keys(transport).map(key => transport[key]).filter(obj => obj);

            const request = newLoan.toAny();
            const sd = newLoan.scheduleDates.toObject();
            request.companyID = this.currentEmployee.workInformation.companyRef.companyID;
            this.dataService.saveLoanRequest(request, sd).then(() => {
              this.ui.stopSpinner();
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'El préstamo ha sido aprobado automáticamente.',
                  close: 'Aceptar'
                }
              });
              this.newLoan = new Loan();
              this.loanCopy = new Loan();
              this.originalLoan = new Loan();
            }).catch(error => {

              this.ui.stopSpinner();
            });
            await this.dataService.saveLogEmployeeLoanChanges(request, 'rl -' + authUser.uid);
          } else {

            const request = newLoan.toAny();
            const sd = newLoan.scheduleDates.toObject();
            request.companyID = this.currentEmployee.workInformation.companyRef.companyID;
            // await this.dataService.updateNotifications(this.currentEmployee.workInformation.supervisor.employeeNumber, 1);
            this.dataService.saveLoanRequest(request, sd).then(() => {
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'Los cambios se han guardado exitosamente y la información ha sido enviada a su jefe inmediato para revisión',
                  close: 'Aceptar'
                }
              });
              this.newLoan = new Loan();
              this.loanCopy = new Loan();
              this.originalLoan = new Loan();
            });
            await this.dataService.saveLogEmployeeLoanChanges(request, 'rl -' + authUser.uid);
            this.ui.stopSpinner();
          }


        }).catch(error => {
          this.ui.stopSpinner();
          console.log(error);
        });
      }
    });

  }

  saveAdvanceLoanPayment() {

    if (this.remainderPayment > this.currentEmployee.wageLiquidity) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No es posible adelantar su pago ya que no se cuenta con la liquidez necesaria.',
          close: 'Aceptar'
        }
      });

      return;
    }


    if (this.loanCopy.scheduleDates.values().length === this.remainderPayment) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'No es posible adelantar su pago ya que es necesario haber realizado un pago.',
          close: 'Aceptar'
        }
      });

      return;
    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `¿Está seguro(a) que desea liquidar $${this.remainderPayment.toFixed(2)} por pago anticipado?`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {

        this.ui.showSpinner();
        const id = this.originalLoan.loanID;

        this.originalLoan.status = LoanStatus.ADVANCE_PAYMENT;
        const startOfDay = this.originalLoan.convertToCDMXSEC(new Date());
        const transport = this.originalLoan.generateTransportMessage(null);
        const keys = Object.keys(transport);

        this.dataService.markAdvanceLoanPayment(id).then(() => {

          this.ui.stopSpinner();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Se ha pagado de forma anticipada tu préstamo exitosamente',
              close: 'Aceptar'
            }
          });
          this.newLoan = new Loan();
          this.loanCopy = new Loan();
          this.originalLoan = new Loan();
          this.cancelSimple(1, null);
        }).catch(error => {
          this.ui.stopSpinner();
        });
      }
    });
  }

  get downloadURLLink(): string | null {

    if (this.retirementSavingParameter) {
      return this.retirementSavingParameter.applicableLoanParameter.downloadLink();
    }

    return null;

  }

  get scheduleDatesValues(): Array<LoanScheduleDate> {
    const values = this.loanCopy.scheduleDates.values();
    values.sort((p, n) => p.depositDate.getTime() - n.depositDate.getTime());
    return values;
  }

  ngOnDestroy(): void {
    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }

    this.loanCopy = new Loan();
    this.originalLoan = new Loan();

  }

}
